import React, { useEffect, useRef, useState } from 'react';
import { useTheme, useMediaQuery, CssBaseline } from '@mui/material';
import { HomeOutlined, ViewCarouselOutlined, Menu, LoginOutlined, PeopleOutline, ExpandMore, ExpandLess, MenuOpen, RedeemOutlined, LocalActivity, PowerSettingsNewOutlined, CalendarMonthOutlined, ShoppingBagOutlined, StorefrontOutlined, ListOutlined, LocalOfferOutlined, ConfirmationNumberOutlined, AccessibilityOutlined, FileCopyOutlined, RedeemRounded, ViewListOutlined, ListAltOutlined, AssignmentOutlined, ReceiptOutlined, NotificationsOutlined, AddOutlined, EqualizerOutlined } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import logo from '../assets/imagenes/splash.png';
import Footers from './Footers';
import { setToken } from '../redux/actions/action';
import { Helmet } from 'react-helmet';
import { PaletaColor } from '../styles/StylesConstantes';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';

function HeaderCustom({ children, id }) {
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
    const [expandedGroups, setExpandedGroups] = useState({});
    const [expandedItems, setExpandedItems] = useState({});
    const menuContainerRef = useRef(null);

    const stateToken = useSelector(state => state.reducerGlobal.token);
    const theme = useTheme();
    const isMatch = useMediaQuery(theme.breakpoints.down('sm'));
    let history = useNavigate();
    let location = window.location.pathname;
    const dispatch = useDispatch();

    const handleTitle = () => 'Inicio';

    const handleRedireccion = (ruta) => {
        history(ruta);
    };

    const handleHome = () => {
        history('/');
    };

    const handleClose = () => {
        localStorage.removeItem('dataUser');
        dispatch(setToken(null));
        history('/app/login');
        window.location.reload();
    };



    const arrayMenu = [
        //  {
        //     id: 1,
        //     name: 'Dashboard',
        //     icon: <HomeOutlined style={{ color: PaletaColor.NEGRO }} />,
        //     ruta: '/app/admin',
        //     action: () => handleRedireccion('/app/admin')
        // },
        {
            id: 2,
            name: 'Inicio',
            icon: <HomeOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin',
            action: () => handleRedireccion('/app/admin')
        },
        {
            id: 3,
            name: 'Usuarios',
            icon: <PeopleOutline style={{ color: PaletaColor.NEGRO }} />,
            children: [
                {
                    id: 3,
                    name: 'Usuarios App',
                    icon: <PeopleOutline style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/usuarios-app',
                    action: () => handleRedireccion('/app/admin/usuarios-app')
                },
                {
                    id: 4,
                    name: 'Usuarios Locales',
                    icon: <PeopleOutline style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/usuarios-locales',
                    action: () => handleRedireccion('/app/admin/usuarios-locales')
                }
            ]
        },
        {
            id: 4,
            name: 'Activaciones',
            icon: <PowerSettingsNewOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/activaciones',
            action: () => handleRedireccion('/app/admin/activaciones')

        },
        {
            id: 5,
            name: 'Paseo Plus',
            icon: <LocalActivity style={{ color: PaletaColor.NEGRO }} />,
            children: [
                // {
                //     id: 3,
                //     name: 'Promociones',
                //     icon: <RedeemOutlined style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/paseo-plus-promociones',
                //     action: () => handleRedireccion('/app/admin/paseo-plus-promociones')
                // },
                // {
                //     id: 4,
                //     name: 'Usuarios para locales',
                //     icon: <PeopleOutline style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/paseo-plus-user-locales',
                //     action: () => handleRedireccion('/app/admin/paseo-plus-user-locales')
                // },
                {
                    id: 5,
                    name: 'Vales',
                    icon: <ReceiptOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/paseo-plus/vales',
                    action: () => handleRedireccion('/app/admin/paseo-plus/vales')
                },

                // {
                //     id: 7,
                //     name: 'Canjes',
                //     icon: <ListAltOutlined style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/paseo-plus/canjes',
                //     action: () => handleRedireccion('/app/admin/paseo-plus/canjes')
                // },
            ]
        },
        {
            id: 6,
            name: 'Reportes',
            icon: <CalendarMonthOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/paseo-plus/reportes',
            action: () => handleRedireccion('/app/admin/paseo-plus/reportes')

        },
        {
            id: 7,
            name: 'Gift Cards',
            icon: <LocalActivity style={{ color: PaletaColor.NEGRO }} />,
            children: [
                {
                    id: 6,
                    name: 'GiftCard',
                    icon: <ConfirmationNumberOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/paseo-plus/gift-card',
                    action: () => handleRedireccion('/app/admin/paseo-plus/gift-card')
                },
                {
                    id: 8,
                    name: 'Empresas',
                    icon: <StorefrontOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/paseo-plus/locales',
                    action: () => handleRedireccion('/app/admin/paseo-plus/locales')
                },
                {
                    id: 9,
                    name: 'Compras',
                    icon: <LocalOfferOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/compras',
                    action: () => handleRedireccion('/app/admin/compras')
                },
                // {
                //     id: 10,
                //     name: 'Reportes',
                //     icon: <EqualizerOutlined style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/paseo-plus/reportes',
                //     action: () => handleRedireccion('/app/admin/paseo-plus/reportes')
                // },
            ]
        },
        {
            id: 8,
            name: 'Eventos',
            icon: <CalendarMonthOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/eventos',
            action: () => handleRedireccion('/app/admin/eventos')

        },
        {
            id: 9,
            name: 'Promociones',
            icon: <ShoppingBagOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/promociones',
            action: () => handleRedireccion('/app/admin/promociones')

        },
        {
            id: 10,
            name: 'Locales',
            icon: <StorefrontOutlined style={{ color: PaletaColor.NEGRO }} />,
            children: [
                {
                    id: 3,
                    name: 'Locales',
                    icon: <StorefrontOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/locales',
                    action: () => handleRedireccion('/app/admin/locales')
                },
                {
                    id: 4,
                    name: 'Categorias',
                    icon: <ListOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/locales-categorias',
                    action: () => handleRedireccion('/app/admin/locales-categorias')
                }
            ]
        },
        {
            id: 11,
            name: 'Beneficios',
            icon: <LocalOfferOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/beneficios',
            action: () => handleRedireccion('/app/admin/beneficios')
            // children: [
            //     {
            //         id: 3,
            //         name: 'Beneficios',
            //         icon: <LocalOfferOutlined style={{ color: PaletaColor.NEGRO }} />,
            //         ruta: '/app/admin/beneficios',
            //         action: () => handleRedireccion('/app/admin/beneficios')
            //     },
            //     // {
            //     //     id: 4,
            //     //     name: 'Beneficios Especiales',
            //     //     icon: <LocalOfferOutlined style={{ color: PaletaColor.NEGRO }} />,
            //     //     ruta: '/app/admin/beneficios-especiales',
            //     //     action: () => handleRedireccion('/app/admin/beneficios-especiales')
            //     // }
            // ]
        },
        {
            id: 12,
            name: 'Sorteos',
            icon: <ConfirmationNumberOutlined style={{ color: PaletaColor.NEGRO }} />,
            // ruta: '/app/admin/sorteos',
            // action: () => handleRedireccion('/app/admin/sorteos')
            children: [
                {
                    id: 1,
                    name: 'Sorteos',
                    icon: <FileCopyOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/sorteos',
                    action: () => handleRedireccion('/app/admin/sorteos')
                },
                {
                    id: 2,
                    name: 'Cupones',
                    icon: <FileCopyOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/cupones',
                    action: () => handleRedireccion('/app/admin/cupones')
                },
            ]

        },
        // {
        //     id: 10,
        //     name: 'Cupones',
        //     icon: <ConfirmationNumberOutlined style={{ color: PaletaColor.NEGRO }} />,
        //     ruta: '/app/admin/cupones',
        //     action: () => handleRedireccion('/app/admin/cupones')

        // },
        {
            id: 13,
            name: 'Banners',
            icon: <ViewCarouselOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/banners',
            action: () => handleRedireccion('/app/admin/banners')

        },
        {
            id: 14,
            name: 'ATC',
            icon: <AccessibilityOutlined style={{ color: PaletaColor.NEGRO }} />,
            // action: handleHome
            children: [
                {
                    id: 1,
                    name: 'Crear transacción',
                    icon: <FileCopyOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/atc/transaccion',
                    action: () => handleRedireccion('/app/admin/atc/transaccion')
                },
                {
                    id: 2,
                    name: 'Items',
                    icon: <FileCopyOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/atc/itmes',
                    action: () => handleRedireccion('/app/admin/atc/itmes')
                },
                {
                    id: 3,
                    name: 'Historial',
                    icon: <FileCopyOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/atc/historial',
                    action: () => handleRedireccion('/app/admin/atc/historial')
                }
            ]
        },
        {
            id: 15,
            name: 'Obsequios',
            icon: <RedeemRounded style={{ color: PaletaColor.NEGRO }} />,
            // action: () => handleRedireccion('/app/admin/obsequios/listar')
            children: [
                {
                    id: 1,
                    name: 'Obsequios',
                    icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/obsequios/listar',
                    action: () => handleRedireccion('/app/admin/obsequios/listar')
                },
                {
                    id: 2,
                    name: 'Listar facturas de obsequios',
                    icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/obsequios/listar-facturas',
                    action: () => handleRedireccion('/app/admin/obsequios/listar-facturas')
                },
                {
                    id: 3,
                    name: 'Filtrar facturas de obsequios vigentes',
                    icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/obsequios/filtrar',
                    action: () => handleRedireccion('/app/admin/obsequios/filtrar')
                },
                // {
                //     id: 3,
                //     name: 'SubCategorias',
                //     icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/obsequios/subcategoriass',
                //     action: () => handleRedireccion('/app/admin/obsequios/subcategorias')
                // },
                // {
                //     id: 4,
                //     name: 'Informe General',
                //     icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/obsequios/informe-general',
                //     action: () => handleRedireccion('/app/admin/obsequios/informe-general')
                // }
            ]
            // children: [
            //     {
            //         id: 1,
            //         name: 'Obsequios',
            //         icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
            //         ruta: '/app/admin/obsequios/listar',
            //         action: () => handleRedireccion('/app/admin/obsequios/listar')
            //     },
            //     {
            //         id: 2,
            //         name: 'Categorias',
            //         icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
            //         ruta: '/app/admin/obsequios/categorias',
            //         action: () => handleRedireccion('/app/admin/obsequios/categorias')
            //     },
            //     {
            //         id: 3,
            //         name: 'SubCategorias',
            //         icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
            //         ruta: '/app/admin/obsequios/subcategoriass',
            //         action: () => handleRedireccion('/app/admin/obsequios/subcategorias')
            //     },
            //     {
            //         id: 4,
            //         name: 'Informe General',
            //         icon: <ViewListOutlined style={{ color: PaletaColor.NEGRO }} />,
            //         ruta: '/app/admin/obsequios/informe-general',
            //         action: () => handleRedireccion('/app/admin/obsequios/informe-general')
            //     }
            // ]
        },
        {
            id: 16,
            name: 'Encuestas',
            icon: <ListAltOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/encuestas/listar',
            action: () => handleRedireccion('/app/admin/encuestas/listar')

        },
        {
            id: 17,
            name: 'Facturas',
            icon: <AssignmentOutlined style={{ color: PaletaColor.NEGRO }} />,
            children: [
                {
                    id: 3,
                    name: 'Facturas',
                    icon: <AssignmentOutlined style={{ color: PaletaColor.NEGRO }} />,
                    ruta: '/app/admin/facturas',
                    action: () => handleRedireccion('/app/admin/facturas')
                },
                // {
                //     id: 4,
                //     name: 'Facturas Pendientes',
                //     icon: <AssignmentOutlined style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/facturas-pendientes',
                //     action: () => handleRedireccion('/app/admin/facturas-pendientes')
                // },
                // {
                //     id: 5,
                //     name: 'Facturas Doble Check',
                //     icon: <AssignmentOutlined style={{ color: PaletaColor.NEGRO }} />,
                //     ruta: '/app/admin/facturas-doble-check',
                //     action: () => handleRedireccion('/app/admin/facturas-doble-check')
                // }
            ]
        },
        {
            id: 18,
            name: 'Notificaciones',
            icon: <NotificationsOutlined style={{ color: PaletaColor.NEGRO }} />,
            ruta: '/app/admin/facturas',
            action: () => handleRedireccion('/app/admin/notificaciones')
            // children: [
            //     {
            //         id: 3,
            //         name: 'Crear Notificación',
            //         icon: <AddOutlined style={{ color: PaletaColor.NEGRO }} />,
            //         ruta: '/app/admin/notificacion-add',
            //         action: () => handleRedireccion('/app/admin/notificacion-add')
            //     },
            //     {
            //         id: 4,
            //         name: 'Historial',
            //         icon: <AssignmentOutlined style={{ color: PaletaColor.NEGRO }} />,
            //         ruta: '/app/admin/facturas',
            //         action: () => handleRedireccion('/app/admin/notificaciones')
            //     },

            // ]
        },
        // {
        //     id: 17,
        //     name: 'Compras',
        //     icon: <LocalOfferOutlined style={{ color: PaletaColor.NEGRO }} />,
        //     ruta: '/app/admin/compras',
        //     action: () => handleRedireccion('/app/admin/compras')
        // },
        {
            id: 19,
            name: 'Cerrar Sesion',
            icon: <LoginOutlined style={{ color: PaletaColor.NEGRO }} />,
            action: handleClose
        },
    ]

    // Definir los 4 grupos de navegación
    const getMenuByName = (name) => arrayMenu.find((item) => item.name === name);

    const toToolbarItems = (menuNames) => {
        return menuNames
            .map((name) => getMenuByName(name))
            .filter(Boolean);
    };

    const toolbarGroups = [
        {
            id: 'inicio',
            label: 'Dashboard',
            items: toToolbarItems(['Inicio'])
            // items: toToolbarItems(['Cupones', 'Sorteos', 'Obsequios'])
        },
        {
            id: 'marketing',
            label: 'Marketing',
            // items: toToolbarItems(['Inicio', 'Eventos', 'Promociones', 'Banners', 'Encuestas', 'Beneficios', 'Notificaciones', 'Usuarios'])
            items: toToolbarItems(['Eventos', 'Promociones', 'Banners', 'Encuestas', 'Beneficios', 'Notificaciones', 'Usuarios'])
        },
        {
            id: 'fidelizacion',
            label: 'Fidelización',
            items: toToolbarItems(['Reportes', 'Paseo Plus', 'Gift Cards', 'Cupones', 'Sorteos', 'Obsequios', 'Compras'])
            // items: toToolbarItems(['Cupones', 'Sorteos', 'Obsequios'])
        },
        // {
        //     id: 'fidelizacion',
        //     label: 'Fidelización',
        //     items: toToolbarItems(['Paseo Plus y Gift Cards', 'Cupones', 'Sorteos', 'Obsequios'])
        //     // items: toToolbarItems(['Cupones', 'Sorteos', 'Obsequios'])
        // },
        {
            id: 'operaciones',
            label: 'Operaciones',
            // items: toToolbarItems(['Activaciones', 'Locales', 'Facturas', 'Notificaciones'])
            items: toToolbarItems(['Locales', 'Facturas'])
        },
        // {
        //     id: 'soporte',
        //     label: 'Soporte',
        //     // items: toToolbarItems(['Usuarios App', 'ATC'])
        //     items: toToolbarItems(['ATC'])
        // }
    ];

    const toggleGroup = (groupId, group) => {
        if (group.items && group.items.length > 1) {
            setExpandedGroups(prev => {
                const isOpening = !prev[groupId];

                // Accordion: when opening one group, close all other groups and their expanded items.
                setExpandedItems(prevItems => {
                    const nextItems = { ...prevItems };
                    Object.keys(nextItems).forEach((key) => {
                        if (!key.startsWith(`${groupId}-`)) {
                            delete nextItems[key];
                        }
                    });

                    if (!isOpening) {
                        Object.keys(nextItems).forEach((key) => {
                            if (key.startsWith(`${groupId}-`)) {
                                delete nextItems[key];
                            }
                        });
                    }

                    return nextItems;
                });

                return {
                    marketing: false,
                    fidelizacion: false,
                    operaciones: false,
                    soporte: false,
                    [groupId]: isOpening,
                };
            });
        } else if (group.items && group.items.length === 1) {
            const item = group.items[0];
            if (item.action) {
                item.action();
            }
        }
    };

    const getItemKey = (groupId, itemIdx) => `${groupId}-${itemIdx}`;

    const toggleItem = (groupId, itemIdx) => {
        const key = getItemKey(groupId, itemIdx);
        setExpandedItems((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleMenuItemClick = (item) => {
        if (item.children && item.children.length > 0) {
            return;
        } else if (item.action) {
            item.action();
        }
    };

    const handleChildItemClick = (childItem) => {
        if (childItem.action) {
            childItem.action();
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!menuContainerRef.current) return;

            if (!menuContainerRef.current.contains(event.target)) {
                setExpandedGroups({
                    marketing: false,
                    fidelizacion: false,
                    operaciones: false,
                    soporte: false,
                });
                setExpandedItems({});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // console.log("toolbarGroups", toolbarGroups);

    return (
        <div>
            <Helmet>
                <title>{handleTitle()}</title>
                <meta name="description" content="Paseo la galeria" />
                <meta name="keywords" content="Paseo la galeria" />
                <meta name="author" content="Paseo la galeria" />
                <meta name="theme-color" content="#008f68" />
                <meta name="apple-mobile-web-app-status-bar-style" content="#008f68" />
                <meta name="msapplication-navbutton-color" content="#008f68" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="mobile-web-app-capable" content="yes"></meta>
                <meta name="robots" content="index, follow" />
                <meta name="googlebot" content="index, follow" />
                <meta name="google" content="notranslate" />
                <meta name="format-detection" content="telephone=no" />
                <meta name="revisit-after" content="1 days" />
                <meta name="language" content="Spanish" />
            </Helmet>
            <CssBaseline />

            {/* HEADER TOOLBAR */}
            <div className="bg-transparent">
                <div className="px-4 py-3">
                    <div className="flex items-center justify-between w-full h-16">
                        <img src={logo} alt="logo" className="w-16 h-16 object-cover" />

                        {stateToken ? (
                            <div className="flex items-center gap-4 flex-1 ml-6">
                                {/* TOOLBAR BUTTONS */}
                                <div ref={menuContainerRef} className="flex gap-6">
                                    {toolbarGroups.map((group) => (
                                        <div key={group.id} className="relative group">
                                            <button
                                                onClick={() => toggleGroup(group.id, group)}
                                                className="text-base font-semibold transition duration-200 flex items-center gap-2 hover:opacity-80"
                                                style={{ color: PaletaColor.HEADER_COLOR }}
                                            >
                                                {group.label}

                                                {group.items && group.items.length > 1 &&
                                                    <>
                                                        {expandedGroups[group.id] ? (
                                                            <ExpandLess style={{ fontSize: 20 }} />
                                                        ) : (
                                                            <ExpandMore style={{ fontSize: 20 }} />
                                                        )}
                                                    </>
                                                }

                                            </button>

                                            {/* DROPDOWN MENU */}
                                            {expandedGroups[group.id] && (
                                                <div className="absolute left-0 top-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 min-w-max">
                                                    {group.items.map((item, itemIdx) => (
                                                        <div key={`${group.id}-item-${itemIdx}`}>
                                                            <button
                                                                onClick={() => {
                                                                    if (item.children && item.children.length > 0) {
                                                                        toggleItem(group.id, itemIdx);
                                                                    } else {
                                                                        handleMenuItemClick(item);
                                                                        setExpandedGroups(prev => ({
                                                                            ...prev,
                                                                            [group.id]: false
                                                                        }));
                                                                    }
                                                                }}
                                                                className="w-full text-left px-4 py-3 hover:bg-gray-100 flex items-center justify-between text-gray-800 text-sm font-medium border-b border-gray-100 last:border-b-0"
                                                            >
                                                                <span>{item.name}</span>
                                                                {item.children && item.children.length > 0 && (
                                                                    expandedItems[getItemKey(group.id, itemIdx)]
                                                                        ? <ExpandLess style={{ fontSize: 16 }} />
                                                                        : <ExpandMore style={{ fontSize: 16 }} />
                                                                )}
                                                            </button>

                                                            {/* SUBOPCIONES */}
                                                            {item.children && item.children.length > 0 && expandedItems[getItemKey(group.id, itemIdx)] && (
                                                                <div className="bg-gray-50 border-t border-gray-200">
                                                                    {item.children.map((child, childIdx) => (
                                                                        <button
                                                                            key={`${group.id}-child-${itemIdx}-${childIdx}`}
                                                                            onClick={() => {
                                                                                handleChildItemClick(child);
                                                                                setExpandedGroups(prev => ({
                                                                                    ...prev,
                                                                                    [group.id]: false
                                                                                }));
                                                                            }}
                                                                            className="w-full text-left px-6 py-2 hover:bg-blue-50 text-gray-700 text-xs border-b border-gray-100 last:border-b-0 transition duration-150"
                                                                        >
                                                                            {child.name}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                {/* USER INFO & LOGOUT */}
                                <div className="flex-1"></div>
                                <div className="flex flex-col justify-center mr-4">
                                    <span className="text-xs" style={{ color: PaletaColor.HEADER_COLOR }}>
                                        {stateToken?.body?.usuario}
                                    </span>
                                    <span className="text-xs" style={{ color: PaletaColor.HEADER_COLOR }}>
                                        {stateToken?.body?.correo}
                                    </span>
                                </div>
                                <button
                                    onClick={handleClose}
                                    className="text-base font-semibold hover:opacity-80 transition duration-200"
                                    style={{ color: PaletaColor.HEADER_COLOR }}
                                >
                                    Cerrar Sesion
                                </button>
                            </div>
                        ) : (
                            <button
                                onClick={handleHome}
                                className="text-base font-semibold hover:opacity-80 transition duration-200"
                                style={{ color: PaletaColor.HEADER_COLOR }}
                            >
                                Inicio
                            </button>
                        )}
                    </div>
                </div>
            </div>



            {/* MAIN CONTENT */}
            <main className="flex flex-col min-h-screen bg-blue-50">
                <div className="flex-1">
                    {children}
                </div>
                <Footers />
            </main>
        </div>
    );
}

export default HeaderCustom;